import React from "react";
import "./Conditions.css";

export default function Conditions(props) {
  const clickHandler = () => {
    props.onHide();
  };

  const handleClick = () => {
    console.log("click shod");
  };

  const jandleh6clik = () => {
    console.log("h6 click shod");
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <div className="backBtn" onClick={clickHandler}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="conditionsBackBtn"
                viewBox="0 0 34 34"
                fill="none"
              >
                <path
                  d="M21.8 1L12.2 1C4.20001 1 1.00001 4.2 1.00001 12.2L1.00001 21.8C1 29.8 4.2 33 12.2 33L21.8 33C29.8 33 33 29.8 33 21.8L33 12.2C33 4.2 29.8 1 21.8 1Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19.0156 11.3517L13.3836 16.9997L19.0156 22.6477"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="conditions">
            <h3>شرایط و قوانین</h3>
            <div
              className="conditionsContent scroll responsiveWidth"
              onClick={handleClick}
            >
              <h6 onClick={jandleh6clik}>بند 1</h6>
              <p>
                با پذیرش سیاست حفظ حریم خصوصی و شرایط ثبت نام کاربر، شما صراحتا
                رضایت خود را با جمع آوری، نگهداری و استفاده از اطلاعات خود،
                مطابق با آنچه در سیاست حفظ حریم خصوصی توضیح داده میشود، اعلام می
                کنید.
              </p>
              <h6>بند 2</h6>
              <p>
                شماره همراه، نام و نام خانوادگی کاربر تنها برای ایجاد حساب
                کاربری استفاده می شود و هیچگونه استفاده دیگری از آن نخواهد شد.
              </p>
              <h6>بند 3</h6>
              <p>
                اطلاعات کاربر تنها در اختیار رِدرُز خواهد بود و هرگونه سعی و
                تلاش در راستای دستیابی به این نوع اطلاعات خلاف قوانین بوده و در
                صورت مشاهده مورد مشکوک، فرد خاطی مورد پیگرد قانونی قرار خواهد
                گرفت.
              </p>
              <h6>بند 4</h6>
              <p>
                برای ثبت نام و احراز هویت کاربر از ارسال کد فعالسازی استفاده شده
                است که پس از مدت زمان محدودی منقضی خواهد شد و کاربران باید شماره
                همراه مربوط به خود را استفاده نمایند تا از هرگونه سوء استفاده و
                جعل حساب جلوگیری شود. همچنین مسئولیت هرگونه به اشتراک گذاری کد
                فعالسازی ارسالی به کاربر با دیگران و اشخاص ناشناس بر عهده مالک
                شماره می باشد.
              </p>
              <h6>بند 5</h6>
              <p>
                هرگونه سوء استفاده از سورس کد برنامه و اجرای عملیات مهندسی معکوس
                روی آن خلاف قوانین بوده و در صورت شناسایی فرد خاطی مورد پیگرد
                قانونی قرار خواهد گرفت.
              </p>
              <button onClick={clickHandler} className="conditionsBtn">
                فهمیدم
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
